import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Lenis from 'lenis';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import { Toaster } from '../ui/sonner';

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();

  // Normalise trailing slashes to the canonical no-slash URL (migration safety)
  useEffect(() => {
    if (location.pathname !== '/' && location.pathname.endsWith('/')) {
      navigate(location.pathname.replace(/\/+$/, '') + location.search + location.hash, {
        replace: true,
      });
    }
  }, [location.pathname, location.search, location.hash, navigate]);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    window.lenis = lenis;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="App relative min-h-screen bg-mist text-navy">
      <Header />
      <main data-testid="main-content" className="overflow-x-hidden">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </div>
  );
}
